// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"BN-z","upvoteIcon":"CN-z","downvoteIcon":"DN-z","feedbackIcon":"EN-z"};